import { intersection, map, pipe, pluck, isEmpty, apply } from 'ramda';
import { MediaManagerSDKAnyItem, MediaManagerSDKFolder } from '../media-manager-sdk';

type TCanPasteHere = (targetFolderPath: MediaManagerSDKFolder[], sourceItems: MediaManagerSDKAnyItem[]) => boolean;
export const canPasteItemsFromTo: TCanPasteHere = (targetFolderPath, sourceItems) =>
  pipe(map(pluck('id')), apply(intersection), isEmpty)([targetFolderPath, sourceItems]);
